import { render } from "./PieDePagina.vue?vue&type=template&id=5da45868&scoped=true"
import script from "./PieDePagina.vue?vue&type=script&lang=js"
export * from "./PieDePagina.vue?vue&type=script&lang=js"

import "./PieDePagina.vue?vue&type=style&index=0&id=5da45868&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da45868"]])

export default __exports__